import NumberRangeController from './number_range_controller';
import { applyServerValue } from '../../utils/select/native_select';

export default class NumberRangeWithUnitSelectController extends NumberRangeController {
  static targets = ['unit'];
  static values = { serverUnit: String };

  _getUnit() {
    return this.unitTarget.value ?? '';
  }

  _applyServerValues() {
    super._applyServerValues();
    applyServerValue(this.unitTarget, this.serverUnitValue);
  }
}
